import React from "react";
import { motion } from "framer-motion";
import { GlobeIcon, TimerIcon, FlameIcon } from "lucide-react";
import { useLoopCountdown } from "../hooks/useLoopCountdown";
import { SPOTS_LEFT, SPOTS_TOTAL } from "../data/content";
type OfferUrgencyProps = {
  dark?: boolean;
};
export function OfferUrgency({
  dark = false
}: OfferUrgencyProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopCountdown();
  const filled = (SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100;
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="mx-auto mt-7 w-full max-w-xl space-y-5" data-id="element-33" data-mp="2wjxvcw8hz6im">
      <div className={`rounded-2xl p-4 sm:p-5 ${dark ? "bg-white/10" : "bg-navy"}`} data-id="element-34" data-mp="31jkajb7vywu2">
        <p className="flex items-center justify-center gap-2 text-center font-display text-base font-semibold text-sun" data-id="element-35" data-mp="buia0gs1sa0d">
          <TimerIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="gt37w9jtuhln" />
          The promotional price ends in:
        </p>
        <div className="mt-3 grid grid-cols-3 gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-37" data-mp="668ez8i8z5k8">
          {units.map(u => <div key={u.label} className="rounded-xl bg-white py-3 text-center" data-id="element-38" data-mp="19866pu0jopf">
              <span className="block font-display text-4xl font-bold tabular-nums text-navy sm:text-5xl" data-id="element-39" data-mp="3tawqtptmku7x">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-ink-soft" data-id="element-40" data-mp="3jebkn15vdd2i">{u.label}</span>
            </div>)}
        </div>
      </div>

      <div data-id="element-41" data-mp="3elifwdaei4qf">
        <div className="flex items-center justify-between gap-3" data-id="element-42" data-mp="39nyyx5mbjdus">
          <p className={`flex items-center gap-1.5 text-sm font-extrabold sm:text-base ${dark ? "text-white" : "text-navy"}`} data-id="element-43" data-mp="39m5r3mzyynl7">
            <FlameIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-44" data-mp="30nk8xsyetaky" />
            Only {SPOTS_LEFT} spots left at the promo price!
          </p>
          <span className={`shrink-0 text-sm font-extrabold ${dark ? "text-sun" : "text-cta"}`} data-id="element-45" data-mp="2voza9xyt2yym">{Math.round(filled)}%</span>
        </div>
        <div className={`mt-2 h-5 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-blush ring-1 ring-cta/20"}`} role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-46" data-mp="2qzyal0h0ojh9">
          <motion.div className="h-full rounded-full bg-cta" initial={{
          width: "60%"
        }} whileInView={{
          width: `${filled}%`
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-47" data-mp="34r321fa8e5gi" />
        </div>
        <p className={`mt-2 text-xs font-semibold ${dark ? "text-white/70" : "text-ink-soft"}`} data-id="element-48" data-mp="2zzur2et96c18">
          {SPOTS_TOTAL - SPOTS_LEFT} of {SPOTS_TOTAL} promotional spots already claimed.
        </p>
      </div>

      <p className={`flex items-start justify-center gap-2 rounded-xl px-4 py-3 text-center text-sm font-semibold ${dark ? "bg-white/10 text-white" : "bg-teal-soft text-teal-dark"}`} data-id="element-49" data-mp="3shz0gv96zywq">
        <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-50" data-mp="1c2c48mi1m904" />
        Price in USD — your local currency is converted automatically at checkout.
      </p>
    </div>;
}